export const mobile = /^1(2|3|4|5|6|7|8|9)\d{9}$/
export const landline = /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/
export const doubleNumber = /^[-+]?\d+(\.\d+)?$/
export const chinese = /^[\u0391-\uFFE5]+$/
export const number1 = /^\d+$/
export const english = /^[A-Za-z]+$/
export const email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
// 电话字段，校验数字和-
export const phoneOther = /^[0-9\-]*$/
export const date = /^[1-2][0-9][0-9][0-9]-[0-1]{0,1}[0-9]-[0-3]{0,1}[0-9]$/;
export const dateTime = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;
export const isValidUsername = (str: string) => ['admin', 'editor'].indexOf(str.trim()) >= 0

export const isExternal = (path: string) => /^(https?:|mailto:|tel:)/.test(path)

export const isPhone = (str: string) => /^[0-9]\d{3,16}$/.test(str)
// 座机
export const isLandline = (str: string) => /^[0-9]\d{3,9}$/.test(str)
export const isEmail = (str: string) => /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(str)
// 2位小数
export const isNumber2 = (str: string) => /^\d+(\.\d{1,2})?$/.test(str)
// 正整数
export const isNumber = (str: string) => /^[1-9]\d*$/.test(str)
// 中英文和数字
export const isName = (str: string) => /^[\u0391-\uFFE5a-zA-Z0-9]+$/.test(str)
export const isChinese = (str: string) => /^[\u0391-\uFFE5]+$/.test(str)
// 英文和数字和点
export const isLoginName = (str: string) => /^[a-zA-Z0-9.]+$/.test(str)
// url
export const isUrl = (str: string) => /^((http|ftp|https):\/\/)(([a-zA-Z0-9._-]+\.[a-zA-Z]{2,6})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,4})*(\/[a-zA-Z0-9&%_./-~-]*)?/.test(str)
export const isPassword = (str: string) => /([A-Za-z])+/.test(str)
export const isMobile = (str: string) => /^1(2|3|4|5|6|7|8|9)\d{9}$/.test(str)
